<template>
  <div class="access-selector container">
    <div class="card mt-4">
      <div class="card-body text-center">
        <h2 class="mb-4">Seleziona modalità di accesso</h2>
        
        <div v-if="loading" class="text-center">
          <loading-spinner />
        </div>

        <div v-else class="mb-4">
          <button class="btn btn-primary mx-2" 
            @click="selectMode(false)" 
            :disabled="checkingIntestatario">
            <span v-if="checkingIntestatario" class="spinner-border spinner-border-sm mr-2" role="status"/>
              Accesso Intestatario
          </button>
          
          <button v-if="isCafUser" class="btn btn-success mx-2" @click="selectMode(true)">
            Accesso CAF
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner'
import axios from 'axios'

export default {
  name: 'AccessoCafSelettore',
  components: {
    LoadingSpinner
  },
  data() {
    return {
      loading: true,
      user: null,
      checkingIntestatario: false
    }
  },
  computed: {
    isCafUser() {
      const user = this.$store.state.auth.user
      return user && user.isCafUser
    },
  },
  
  async created () {
    await this.load()
  },

  methods: {
    async load () {
      try {
        this.loading = true
        if (this.$route.params && this.$route.params.delega === 'attiva') {
          // Rimuovi delega
          await this.$store.dispatch('caf/terminaImpersonificazione', { user: this.$store.state.auth.user })
          await this.$store.dispatch('info')
        }

        this.user = this.$store.state.auth.user
      } catch (err) {
        this.$ui.showError(err)
      } finally {
        this.loading = false
      }
    },


    async selectMode(isCaf) {
      try {
        if (!isCaf) {
          if(this.checkingIntestatario) return;
          this.checkingIntestatario = true;

          // Verifica se è intestatario
          const response = await axios.get('/api/auth/checkIntestatario')
          const { isIntestatario } = response.data
          
          if (!isIntestatario) {
            this.$ui.notify({
              type: 'error',
              title: 'Accesso negato',
              message: 'Non risulti essere un intestatario registrato. Accesso non consentito.'
            })
            return
          }
        }

        // Salva la scelta
        sessionStorage.setItem('cafMode', isCaf ? 'true' : 'false')
        
        // Redirect dopo aver salvato la scelta
        if (isCaf) {
          this.$router.push({ name: 'cafDashboard' })
        } else {
          this.$router.push({ name: 'home' })
        }
      }
      catch(err) {
        this.$ui.showError(err)
      }finally {
        this.checkingIntestatario = false
      }
    }
  }
}
</script>